exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropbox{outline:2px dashed grey;outline-offset:-10px;background:#fff;color:dimgray;padding:10px;max-height:3.5em;position:relative}.input-file{opacity:0;width:100%;height:4em;position:absolute}.dropbox:hover{background:#add8e6}.dropbox p{text-align:center;padding:.5em 0}.preview{max-height:20em;width:100%!important;vertical-align:middle!important}.v-input.btnGrade.v-text-field{height:4em}.flex.xs3{max-width:20%!important}.showTick{display:inline}.hideTick{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6029fede","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Settings.vue
// module id = 656
// module chunks = 0